import { render, staticRenderFns } from "./steps-block.vue?vue&type=template&id=45764ed8"
import script from "./steps-block.vue?vue&type=script&lang=js"
export * from "./steps-block.vue?vue&type=script&lang=js"
import style0 from "./steps-block.vue?vue&type=style&index=0&id=45764ed8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports